<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--引导块-->
			<div
				v-if="infoData"
				class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tips_main">
					<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
				</div>
			</div>
			<!--引导块-->
			<!--banner-->
			<div class="banner_box">
				<img
					class="bg"
					src="../../assets/3in1/banner_bg.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box">
					<div class="left">
						<div class="tit"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="200"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/3in1/banner_test_01.webp" />
						</div>
						<div class="txt"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="400"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/3in1/banner_test_02.webp" />
						</div>
						<div class="btn_box"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="600"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/3in1/banner_Button_01.webp" style="margin-right: 30px;" @click="goAl21" />
							<img src="../../assets/3in1/banner_Button_02.webp" @click="goAmazon" />
						</div>
					</div>
				</div>
			</div>
			<!--banner-->
			<!--表单-->
			<!-- <div class="form_box"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="form_main">
					<div class="title">
						<span class="col_org">Limited time offer!</span><br />
						<span class="">Sign up and receive 20% Off</span>
					</div>
					<div class="iframe_box">
						<iframe :src="formUrl" width="100%" height="340px" frameborder="0" allowfullscreen></iframe>
					</div>
				</div>
			</div> -->
			<div v-if="false" class="form_box"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="form_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<span class="">Limited time offer!</span><br />
						<span class="">Sign up NOW, Take 30% off your first purchase</span>
					</div>
					<div class="btn_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="800"
						data-aos-offset="0"
						data-aos-once="true"
						style="padding-top: 30px;"
					>
						<img src="../../assets/3in1/sign-up_icon2.webp" style="width: 17%;" @click="goForm" />
					</div>
				</div>
			</div>
			<!--表单-->
			<!--视频-->
			<div
				class="video_box"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="video_main">
					<div class="title">CorDx Tyfast Flu A/B & COVID-19 Multiplex Rapid Test</div>
					<iframe width="1000" height="562" src="https://www.youtube.com/embed/bQ0NHMYziGw" title="CorDx TyFast Flu A/B &amp; COVID-19 At Home Multiplex Rapid Test" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
				</div>
			</div>
			<!--视频-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="bg">
					<img src="../../assets/3in1/img_01.webp" />
				</div>
				<div class="block_1_main">
					<div class="left"></div>
					<div class="tit_box">
						<div class="tit">
							Simple Testing, <span class="col_org">Reliable Outcomes</span>
						</div>
						<div class="txt">
							Protect yourself and your loved ones year-round. Ideal<br />
							for monitoring symptoms and preventing the spread<br />
							of seasonal illnesses.
						</div>
						<div class="img_box">
							<img src="../../assets/3in1/img_02.webp" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Flu or COVID? <span class="col_org">No More Guessing!</span>
					</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Unsure if your respiratory symptoms, such as fever, sneezing, cough, or fatigue, are from COVID or<br />
						flu? With our at-home 3-in-1 rapid test, quickly find out and get the right care for you and your family.
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<img src="../../assets/3in1/img_03.webp" />
							<div class="tit">Fever or Chills</div>
						</div>
						<div class="list_el">
							<img src="../../assets/3in1/img_04.webp" />
							<div class="tit">Cough</div>
						</div>
						<div class="list_el">
							<img src="../../assets/3in1/img_05.webp" />
							<div class="tit">Difficulty Breathing</div>
						</div>
						<div class="list_el">
							<img src="../../assets/3in1/img_06.webp" />
							<div class="tit">Fatigue</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<span class="col_org">Simple Testing, </span>Reliable Outcomes
					</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Protect yourself and your loved ones year-round. Ideal for monitoring symptoms and preventing<br />
						the spread of seasonal illnesses.
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<img src="../../assets/3in1/img_07.webp" />
							<div class="tit">Swab Nostrils</div>
						</div>
						<div class="list_el">
							<img src="../../assets/3in1/img_08.webp" />
							<div class="tit">Mix Sample & Solution</div>
						</div>
						<div class="list_el">
							<img src="../../assets/3in1/img_09.webp" />
							<div class="tit">Add 3 Drops</div>
						</div>
						<div class="list_el">
							<img src="../../assets/3in1/img_10.webp" />
							<div class="tit">Wait</div>
						</div>
					</div>
					<div class="tips">*please refer to the guick reference instructions or the instructional video for more detailed steps.</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="bg">
					<img src="../../assets/3in1/img_12.webp" />
				</div>
				<div class="block_4_main">
					<div class="tit_box">
						<div class="tit">
							<span class="col_org">Compact Design</span> for on-the-go access.
						</div>
						<div class="txt">
							Its compact design assures not only easy storage but also<br />
							convenient portability in your travel bag, allowing you to <br />
							seamlessly take charge of your health wherever you go.
						</div>
					</div>
					<div class="left"></div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<div class="title">Downloadable Resources</div>
					<template v-if="infoData">
						<div v-if="infoData.tags.length > 0" class="tag_box"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="list_box">
								<div v-for="(value, index) in infoData.tags" :key="index"
									class="list_el"
									:class="nowList == value.id ? 'actived' : ''"
									@click="listClick(value)"
								>{{ value.catname }}</div>
							</div>
							<div class="content" v-html="nowContent"></div>
						</div>
					</template>
				</div>
			</div>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { productInfo, productCount } from '@/api/public';
import md5 from 'js-md5';
import moment from 'moment';
export default {
	components:{
		navbar,
		footerBox,
		fixed
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nowList: null,
			nowContent: '',
			metaDescription: '',
			metaKeywords: '',
			formUrl: 'https://cordx.com/hbspt-form3.html?t='+new Date().getTime()
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求产品信息
		productInfo({
			custom: that.$route.params.productInfoIds,
		}).then(res => {
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			that.isLoading = false;
			//统计访问
			let time = String(moment(new Date()).valueOf());
			setTimeout(() => {
				productCount({
					language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
					cate_id: that.infoData.cate_id,
					cert_id: that.infoData.cert_id,
					productid: that.infoData.id,
					url: that.$route.name,
					addtime: time,
					sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
				}).then(res2 => {});
			}, 10000);
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		//底部列表点击
		listClick(value) {
			let that = this;
			that.nowList = value.id;
			that.nowContent = value.content;
		},
		goAl21() {
			let that = this;
			window.open(that.infoData.buy_url);
		},
		goAmazon() {
			let that = this;
			window.open('https://www.amazon.com/At-Home-CorDx-COVID-19-Accurate-Results/dp/B0D2DQBJS2?maas=maas_adg_EAA5E1BA3E43283FC76983FA6B2A9AFF_afap_abs&ref_=aa_maas&tag=maas');
		},
		goForm() {
			let that = this;
			window.open('https://9503031.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=9503031&formid=24&h=AAFdikaIYcctPmZ3oTQZTGD4gzYwl8OjHC498vc8v2hIIGtF_Ho');
		},
	}
}
</script>

<style scoped lang="less">
.col_org{
	color: #f36f32;
}
.col_blue{
	color: #083388;
}
.main_box{
	color: #000000;
	//块5
	.block_5{
		.block_5_main{
			width: 1140px;
			margin: 0 auto;
			padding: 80px 0 50px 0;
			.tag_box{
				width: 1140px;
				margin: 0 auto;
				padding: 40px 0 50px 0;
				.content{
					margin-top: 30px;
					padding: 0 30px;
					border: 1px solid #0B318F;
				}
				.list_box{
					.list_el{
						display: inline-block;
						margin: 10px 10px 0 0;
						padding: 12px 20px;
						font-size: 18px;
						background-color: #EFEFEF;
						color: #000000;
						cursor: pointer;
					}
					.list_el.actived{
						color: #ffffff;
						background-color: #0B318F;
					}
					.list_el:hover{
						color: #ffffff;
						background-color: #0066D4;
					}
				}
			}
			.title{
				text-align: center;
				font-size: 24px;
				font-weight: bold;
			}
		}
	}
	//视频
	.video_box{
		.video_main{
			width: 1140px;
			margin: 0 auto;
			padding: 50px 0 80px 0;
			text-align: center;
			.title{
				padding-bottom: 35px;
				font-size: 48px;
				font-weight: bold;
				text-align: center;
			}
		}
	}
	//块4
	.block_4{
		// background: url(../../assets/3in1/img_11.webp) no-repeat 100% 100%;
		// background-size: cover;
		position: relative;
		.block_4_main{
			position: absolute;
			top: 0;
			width: 1240px;
			height: 100%;
			display: flex;
			align-items: center;
			left: 50%;
			transform: translate(-50%, 0);
			.left{
				flex: 1;
			}
			.tit_box{
				width: auto;
				padding-left: 160px;
				text-align: right;
				.txt{
					padding-top: 10px;
					color: #ffffff;
					font-size: 22px;
					text-align: center;
				}
				.tit{
					color: #ffffff;
					font-weight: bold;
					font-size: 36px;
					span{
						font-weight: bold;
						font-size: 36px;
					}
				}
			}
		}
		.bg{
			width: 1140px;
			margin: 0 auto;
			img{
				width: 100%;
			}
		}
	}
	//块3
	.block_3{
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			padding: 80px 0;
			.tips{
				padding-top: 50px;
				font-size: 16px;
				text-align: center;
				color: #333333;
			}
			.list_box{
				display: flex;
				padding-top: 40px;
				.list_el:last-child{
					margin-right: 0;;
				}
				.list_el{
					flex: 1;
					margin-right: 30px;
					text-align: center;
					.tit{
						padding-top: 15px;
						font-size: 18px;
					}
					img{
						width: 100%;
					}
				}
			}
			.text{
				padding-top: 25px;
				font-size: 24px;
				text-align: center;
			}
			.title{
				font-weight: bold;
				font-size: 48px;
				text-align: center;
				span{
					font-weight: bold;
					font-size: 48px;
				}
			}
		}
	}
	//块2
	.block_2{
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			padding: 80px 0;
			.list_box{
				display: flex;
				padding-top: 40px;
				.list_el:last-child{
					margin-right: 0;;
				}
				.list_el{
					flex: 1;
					margin-right: 30px;
					text-align: center;
					.tit{
						padding-top: 15px;
						font-size: 18px;
					}
					img{
						width: 100%;
					}
				}
			}
			.text{
				padding-top: 25px;
				font-size: 24px;
				text-align: center;
			}
			.title{
				font-weight: bold;
				font-size: 48px;
				text-align: center;
				span{
					font-weight: bold;
					font-size: 48px;
				}
			}
		}
	}
	//块1
	.block_1{
		// background: url(../../assets/3in1/img_11.webp) no-repeat 100% 100%;
		// background-size: cover;
		position: relative;
		.block_1_main{
			position: absolute;
			top: 0;
			width: 1140px;
			height: 100%;
			display: flex;
			align-items: center;
			left: 50%;
			transform: translate(-50%, 0);
			.left{
				flex: 1;
			}
			.tit_box{
				width: auto;
				padding-right: 160px;
				text-align: right;
				.img_box{
					padding-top: 30px;
					img{
						width: 500px;
					}
				}
				.txt{
					padding-top: 10px;
					color: #ffffff;
					font-size: 22px;
					text-align: center;
				}
				.tit{
					color: #ffffff;
					font-weight: bold;
					font-size: 36px;
					span{
						font-weight: bold;
						font-size: 36px;
					}
				}
			}
		}
		.bg{
			width: 1140px;
			margin: 0 auto;
			img{
				width: 100%;
			}
		}
	}
	//表单
	.form_box{
		padding: 50px 0;
		background-color: #FEFBF3;
		.form_main{
			width: 1140px;
			margin: 0 auto;
			.btn_box{
				text-align: center;
				img{
					cursor: pointer;
				}
			}
			.title{
				text-align: center;
				span{
					font-size: 36px;
				}
			}
		}
	}
	// .form_box{
	// 	.form_main{
	// 		width: 1140px;
	// 		margin: 0 auto;
	// 		.title{
	// 			padding: 0 0 20px 0;
	// 			text-align: center;
	// 			span{
	// 				font-size: 24px;
	// 				font-weight: bold;
	// 			}
	// 		}
	// 	}
	// }
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 1240px;
			height: 100%;
			display: flex;
			align-items: center;
			position: absolute;
			top: 0;
			left: 50%;
			transform: translate(-50%, 0);
			.btn_box{
				padding-top: 40px;
				img{
					display: inline-block;
					width: 16%;
					cursor: pointer;
				}
			}
			.left{
				flex: 1;
				.txt{
					padding-top: 40px;
					img{
						width: 40%;
					}
				}
				.tit{
					img{
						width: 45%;
					}
				}
			}
		}
		img.bg{
			width: 100%;
			min-width: 1240px;
		}
	}
	//引导块
	.tips_box{
		padding: 50px 0 30px 0;
		background: linear-gradient(to right, #F2F7FD, transparent);
		.tips_main{
			width: 1140px;
			margin: 0 auto;
			font-size: 16px;
			span{
				color: #0B318F;
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .block_1_box p{
	margin: 0;
}
</style>